import React, { useEffect, useState } from "react";
import Seo from "../../../Components/SeoComponent/Seo";
import Header from "../../../Components/Header";
import { useService } from "../../../context/ServiceContext";
import { Copy, FileJson, Info, ListCheck, Loader } from "lucide-react";
import {
  getDlLicence,

} from "../../../Services/ApiTestService/apiTestService";
import { fetchProfile } from "../../../Services/ApiTestService/aadharTestService";
import { showErrorToast, showSuccessToast } from "../../../utils/toastUtils";
import { isAlphanumeric, isNumeric } from "validator";

function DlLicence() {
  const [isLoading, setIsLoading] = useState(false);
  const [response, setResponse] = useState(null);

  const [licenceNumber, setLicenceNumber] = useState("");
  const [inputError, setInputError] = useState(null);
  const [isJsonCopied, setIsJsonCopied] = useState(null);
  const [dob, setDob] = useState("");

  const [profileData, setProfileData] = useState(null);
  let apiResponse;

    const { serviceName } = useService();
  

  const isAlpha = (value) => {
    if (!value) return false;

    return isAlphanumeric(String(value).trim(), "en-IN", { ignore: " " });
  };

  const handleCopy = (data) => {
    navigator.clipboard
      .writeText(JSON.stringify(data, null, 2))
      .then(() => showSuccessToast("Copied!"));

    setIsJsonCopied(true);
  };

  const handleDlLicence = async () => {
    if (!profileData) return;

    const validate = isAlpha(licenceNumber);

    if (!licenceNumber) {
      return setInputError("⚠️ Licence Number is required");
    } else if (licenceNumber?.length < 10) {
      return setInputError(
        "⚠️ Please enter at least 10 digits in Licence No. field",
      );
    } else if (!validate) {
      return setInputError(
        "⚠️ Please enter alpha numeric in Licence No. field",
      );
    } else if (!dob) {
      return setInputError("⚠️ Date of Birth is required ");
    }

    try {
      setInputError(null);
      setIsLoading(true);
      setResponse(null);

      const res = await getDlLicence({
        api_id: profileData.user_id,
        api_key: profileData.api_key,
        token_id: profileData.token_id,
        license_num: licenceNumber.trim(),
        dob,
      });

      if (res) {
        apiResponse = res;
      }
      setResponse(apiResponse);

      if (res?.status?.code === 200) {
        showSuccessToast(res?.message || "Success");
      } else if (res?.status?.code === 422) {
        showErrorToast(res?.data?.message || "invalid details ");
      } else if (res?.status?.code === 500) {
        showErrorToast(res?.data?.message || "server error");
      } else if (!res.success) {
        showErrorToast(res?.data?.message || "verificaton failed");
      } else {
        showErrorToast(res?.data?.message || "something went wrong");
      }
    } catch (error) {
      console.error(error);
      showErrorToast("Server error");
    } finally {
      setIsLoading(false);
    }
  };

  // ---------------- FETCH PROFILE ----------------
  useEffect(() => {
    const loadProfile = async () => {
      try {
        setIsLoading(true);
        const res = await fetchProfile();
        setProfileData(res?.data || null);

        if (res) {
          console.log("profile", res);
        }
      } catch (error) {
        console.error(error);
        showErrorToast("Failed to fetch profile");
      } finally {
        setIsLoading(false);
      }
    };

    loadProfile();
  }, []);

  return (
    <>
      <Seo />
      <Header heading={serviceName} />

      {isLoading && (
        <div className="flex justify-center mt-6">
          <Loader className="animate-spin" />
        </div>
      )}

      <div className="w-full min-h-screen flex flex-col items-center justify-start py-14">
        {/* ---------------- FORM ---------------- */}
        <div className=" max-w-3xl border rounded-md sm:p-6 mt-6 bg-white">
          <div className="flex items-start flex-col flex-wrap gap-4">
            {/* Licence */}
            <div className="flex items-center gap-4">
              <label className="w-32 font-bold">
                Licence No <span className="text-red-600">*</span>
              </label>
              <input
                type="text"
                value={licenceNumber}
                onChange={(e) => setLicenceNumber(e.target.value)}
                className="flex-1 border border-gray-400 rounded-md px-3 h-[38px]"
                placeholder="Eg: WB2320150223071"
              />
            </div>
            <div className="flex items-center gap-4">
              <label className="w-32 font-bold">
                Date Of Birth <span className="text-red-600">*</span>
              </label>
              <input
                type="date"
                value={dob}
                onChange={(e) => setDob(e.target.value)}
                className="flex-1 border border-gray-400 rounded-md px-3 h-[38px]"
              />
            </div>

            {/* show input errors */}

            {inputError && (
              <div className="text-red-800 text-xl font-bold">{inputError}</div>
            )}

            {/* Verify Button */}
            <div className="flex justify-end ">
              <button
                disabled={isLoading || !licenceNumber}
                onClick={handleDlLicence}
                className="px-6 py-2 bg-gradient-to-br hover:bg-black active:bg-green-600 from-blue-400 to-blue-800 text-white rounded-sm disabled:opacity-50"
              >
                Verify
              </button>
            </div>
          </div>
        </div>

        {/* response message */}

        {response && (
          <div
            className={` ${response.status?.code === 500 || response.status?.code === 422 ? "text-red-500" : "text-green-600"} py-4 text-2xl font-bold`}
          >
            {response?.data?.message || response?.message}
          </div>
        )}

        {/* instructions */}

        <div className="w-full flex justify-center">
          <div className="bg-green-100 max-w-3xl border border-green-400 text-green-700 p-5 mt-12 rounded-2xl">
            <h3 className="font-bold flex items-center justify-start gap-2 text-lg mb-2">
              <Info /> Important Instructions{" "}
              <span className="text-red-600">*</span>
            </h3>

            <p className="text-sm leading-relaxed">
              Please enter a valid Licence number and Date Of Birth. Clicking
              the Verify button. After successful verification, the system will
              return the response in structured format, including contact
              details associated with the provided details. You may review and
              copy the data for your reference or further use.
            </p>
          </div>
        </div>

        {/* ---------------- RESULT ---------------- */}
        {response?.status?.code === 200 && (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-10 w-full max-w-6xl">
            {/* -------- JSON VIEW -------- */}
            <div className="bg-gray-900 relative text-green-300 p-4 rounded-md overflow-auto">
              <button
                onClick={() => handleCopy(response)}
                className="absolute text-white top-4 right-8"
              >
                {isJsonCopied ? "copied" : <Copy />}
              </button>
              <p className="font-bold mb-2 text-2xl flex items-center justify-start md:justify-center gap-2 text-white">
                <FileJson /> JSON response
              </p>
              <hr className="mb-8" />{" "}
              <pre className="text-[16px]">
                {JSON.stringify(response, null, 2)}
              </pre>
            </div>

            <div className="bg-gray-200 p-5 rounded-md">
              <h2 className="text-2xl flex items-center justify-center font-bold text-blue-500 mb-4">
                All Details
              </h2>

              {/* -------- BASIC INFO -------- */}
              <div className="space-y-2 text-sm">
                <div>
                  <span className="font-semibold w-48 inline-block">
                    Licence No:
                  </span>
                  {response?.data?.licenceNo || "N/A"}
                </div>

                <div>
                  <span className="font-semibold w-48 inline-block">
                    Message:
                  </span>
                  {response?.data?.message || "N/A"}
                </div>

                <div>
                  <span className="font-semibold w-48 inline-block">
                    Status Code:
                  </span>
                  {response?.data?.statusCode || "N/A"}
                </div>
              </div>

              {/* -------- USER DATA -------- */}
              <div className="mt-6">
                <h3 className="font-bold text-lg mb-2">User Details</h3>

                <div className="space-y-2 text-sm">
                  <div>
                    <span className="font-semibold w-48 inline-block">
                      First Name:
                    </span>{" "}
                    {response?.data?.userData?.firstName || "N/A"}
                  </div>
                  <div>
                    <span className="font-semibold w-48 inline-block">
                      Middle Name:
                    </span>{" "}
                    {response?.data?.userData?.middelName || "N/A"}
                  </div>
                  <div>
                    <span className="font-semibold w-48 inline-block">
                      Last Name:
                    </span>{" "}
                    {response?.data?.userData?.lastName || "N/A"}
                  </div>
                  <div>
                    <span className="font-semibold w-48 inline-block">
                      Full Name:
                    </span>{" "}
                    {response?.data?.userData?.fullName || "N/A"}
                  </div>
                  <div>
                    <span className="font-semibold w-48 inline-block">
                      Gender:
                    </span>{" "}
                    {response?.data?.userData?.gender || "N/A"}
                  </div>
                  <div>
                    <span className="font-semibold w-48 inline-block">
                      DOB:
                    </span>{" "}
                    {response?.data?.userData?.dateOfBirth || "N/A"}
                  </div>
                </div>
              </div>

              {/* -------- PERMANENT ADDRESS -------- */}
              <div className="mt-6">
                <h3 className="font-bold text-lg mb-2">Permanent Address</h3>

                <div className="space-y-2 text-sm">
                  <div>
                    <span className="font-semibold w-48 inline-block">
                      Address 1:
                    </span>{" "}
                    {response?.data?.userData?.permanentAddress?.address1 ||
                      "N/A"}
                  </div>
                  <div>
                    <span className="font-semibold w-48 inline-block">
                      Address 2:
                    </span>{" "}
                    {response?.data?.userData?.permanentAddress?.address2 ||
                      "N/A"}
                  </div>
                  <div>
                    <span className="font-semibold w-48 inline-block">
                      Address 3:
                    </span>{" "}
                    {response?.data?.userData?.permanentAddress?.address3 ||
                      "N/A"}
                  </div>
                  <div>
                    <span className="font-semibold w-48 inline-block">
                      Pincode:
                    </span>{" "}
                    {response?.data?.userData?.permanentAddress?.pincode ||
                      "N/A"}
                  </div>
                  <div>
                    <span className="font-semibold w-48 inline-block">
                      District Code:
                    </span>{" "}
                    {response?.data?.userData?.permanentAddress?.districtCode ||
                      "N/A"}
                  </div>
                  <div>
                    <span className="font-semibold w-48 inline-block">
                      Village/Town Code:
                    </span>{" "}
                    {response?.data?.userData?.permanentAddress
                      ?.villageTownCode || "N/A"}
                  </div>
                  <div>
                    <span className="font-semibold w-48 inline-block">
                      Location Type:
                    </span>{" "}
                    {response?.data?.userData?.permanentAddress?.locationType ||
                      "N/A"}
                  </div>
                </div>
              </div>

              {/* -------- CURRENT ADDRESS -------- */}
              <div className="mt-6">
                <h3 className="font-bold text-lg mb-2">Current Address</h3>

                <div className="space-y-2 text-sm">
                  <div>
                    <span className="font-semibold w-48 inline-block">
                      Address 1:
                    </span>{" "}
                    {response?.data?.userData?.currentAddress?.address1 ||
                      "N/A"}
                  </div>
                  <div>
                    <span className="font-semibold w-48 inline-block">
                      Address 2:
                    </span>{" "}
                    {response?.data?.userData?.currentAddress?.address2 ||
                      "N/A"}
                  </div>
                  <div>
                    <span className="font-semibold w-48 inline-block">
                      Address 3:
                    </span>{" "}
                    {response?.data?.userData?.currentAddress?.address3 ||
                      "N/A"}
                  </div>
                  <div>
                    <span className="font-semibold w-48 inline-block">
                      Pincode:
                    </span>{" "}
                    {response?.data?.userData?.currentAddress?.pincode || "N/A"}
                  </div>
                  <div>
                    <span className="font-semibold w-48 inline-block">
                      District Code:
                    </span>{" "}
                    {response?.data?.userData?.currentAddress?.districtCode ||
                      "N/A"}
                  </div>
                  <div>
                    <span className="font-semibold w-48 inline-block">
                      Village/Town Code:
                    </span>{" "}
                    {response?.data?.userData?.currentAddress
                      ?.villageTownCode || "N/A"}
                  </div>
                  <div>
                    <span className="font-semibold w-48 inline-block">
                      Location Type:
                    </span>{" "}
                    {response?.data?.userData?.currentAddress?.locationType ||
                      "N/A"}
                  </div>
                </div>
              </div>

              {/* -------- RTO DATA -------- */}
              <div className="mt-6">
                <h3 className="font-bold text-lg mb-2">RTO Details</h3>

                <div className="space-y-2 text-sm">
                  <div>
                    <span className="font-semibold w-48 inline-block">
                      State Code:
                    </span>{" "}
                    {response?.data?.rtoData?.stateCode || "N/A"}
                  </div>
                  <div>
                    <span className="font-semibold w-48 inline-block">
                      Status:
                    </span>{" "}
                    {response?.data?.rtoData?.status || "N/A"}
                  </div>
                  <div>
                    <span className="font-semibold w-48 inline-block">
                      Valid From:
                    </span>{" "}
                    {response?.data?.rtoData?.validFrom || "N/A"}
                  </div>
                  <div>
                    <span className="font-semibold w-48 inline-block">
                      Valid Upto:
                    </span>{" "}
                    {response?.data?.rtoData?.validUpto || "N/A"}
                  </div>

                  <div>
                    <span className="font-semibold w-48 inline-block">
                      RTO Code:
                    </span>{" "}
                    {response?.data?.rtoData?.rtoData?.rtoCode || "N/A"}
                  </div>
                  <div>
                    <span className="font-semibold w-48 inline-block">
                      RTO Full Name:
                    </span>{" "}
                    {response?.data?.rtoData?.rtoData?.rtoFullName || "N/A"}
                  </div>
                  <div>
                    <span className="font-semibold w-48 inline-block">
                      RTO Short Name:
                    </span>{" "}
                    {response?.data?.rtoData?.rtoData?.rtoShortName || "N/A"}
                  </div>
                  <div>
                    <span className="font-semibold w-48 inline-block">
                      Office Town:
                    </span>{" "}
                    {response?.data?.rtoData?.rtoData?.rtoOfficeTownName ||
                      "N/A"}
                  </div>
                </div>
              </div>

              {/* -------- VEHICLES -------- */}
              {response?.data?.vehiclesCovered?.length > 0 && (
                <div className="mt-6">
                  <h3 className="font-bold text-lg mb-2">Vehicles Covered</h3>

                  {response.data.vehiclesCovered.map((v, i) => (
                    <div
                      key={i}
                      className="border p-3 rounded mb-3 bg-blue-500 text-white"
                    >
                      <div>
                        <b>Code:</b> {v.code || "N/A"}
                      </div>
                      <div>
                        <b>Status:</b> {v.status || "N/A"}
                      </div>
                      <div>
                        <b>Description:</b> {v.description || "N/A"}
                      </div>
                      <div>
                        <b>Abbreviation:</b> {v.abbreviation || "N/A"}
                      </div>
                      <div>
                        <b>Category:</b> {v.category || "N/A"}
                      </div>
                      <div>
                        <b>Issuing Date:</b> {v.issuingDate || "N/A"}
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    </>
  );
}

export default DlLicence;
